import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useSnippetStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function SnippetGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid />
}

export default function SnippetGridLayout() {
  return <GridProvider store={useSnippetStore()}>
    <SnippetGrid />
  </GridProvider>
}
